import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

/**
 * CvxPreset — Aura preset customised with Chevron brand colors.
 *
 * Chevron primary:  #0066b2  (medium blue)
 * Chevron hover:    #0b2d71  (dark blue)
 * Chevron light:    #009dd9  (light blue)
 *
 * The `semantic.primary` palette is a 50–950 ramp generated from the Chevron
 * blue spectrum so all PrimeNG components (Button, Select, Dialog header, etc.)
 * automatically adopt the brand colour.
 */
export const CvxPreset = definePreset(Aura, {
    semantic: {
        primary: {
            50: '#e8f4fb',
            100: '#c5e0f5',
            200: '#9dcde9',
            300: '#66b3d9',
            400: '#3398ca',
            500: '#0066b2', // $color-primary / $color-medium-blue
            600: '#005291',
            700: '#003d6d',
            800: '#0b2d71', // $color-dark-blue / $color-primary-hover
            900: '#091e4b',
            950: '#040f26',
        },
        colorScheme: {
            light: {
                primary: {
                    color: '{primary.500}',
                    contrastColor: '#ffffff',
                    hoverColor: '{primary.800}',
                    activeColor: '{primary.800}',
                },
                highlight: {
                    background: '{primary.500}',
                    focusBackground: '{primary.700}',
                    color: '#ffffff',
                    focusColor: '#ffffff',
                },
                surface: {
                    0: '#ffffff',
                    50: '#fafafa',
                    100: '#f5f5f5',
                    200: '#eeeeee',
                    300: '#e0e0e0',
                    400: '#bdbdbd',
                    500: '#9e9e9e',
                    600: '#757575',
                    700: '#616161',
                    800: '#424242',
                    900: '#212121',
                    950: '#121212',
                },
            },
            dark: {
                primary: {
                    color: '{primary.300}',
                    contrastColor: '{surface.900}',
                    hoverColor: '{primary.200}',
                    activeColor: '{primary.100}',
                },
                highlight: {
                    background: 'rgba(0, 102, 178, 0.16)',
                    focusBackground: 'rgba(0, 102, 178, 0.24)',
                    color: 'rgba(255, 255, 255, 0.87)',
                    focusColor: 'rgba(255, 255, 255, 0.87)',
                },
            },
        },
    },
});
